import { logClickEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { logUserAction } from '@office-start/telemetry-service';
export var useInstrumentActionClick = function (toast) {
    if (!toast || !toast.actionInfo) {
        return;
    }
    var onClickUninstrumented = toast.actionInfo.onClick;
    toast.actionInfo.onClick = function () {
        onClickUninstrumented();
        logClickEvent(KnownInstrumentationEvents.ToastClick, 'toastActionLink', 'Toast');
        logUserAction({
            eventName: KnownInstrumentationEvents.ToastClick,
            id: 'toastActionLink',
            result: 'Create',
            target: 'Toast',
            area: 'Toast',
        });
    };
};
//# sourceMappingURL=useInstrumentActionClick.js.map